import React, { useState, useEffect } from "react"
import { X } from "lucide-react"
import { Link } from "@inertiajs/react"

const SellAGunBanner = () => {
    const [isVisible, setIsVisible] = useState(false)
    const [isDismissed, setIsDismissed] = useState(false)

    const setWithExpiry = (key, value, ttl) => {
        const now = new Date()
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    const getWithExpiry = (key) => {
        const itemStr = localStorage.getItem(key)
        if (!itemStr) {
            return null
        }

        try {
            const item = JSON.parse(itemStr)
            const now = new Date()

            if (now.getTime() > item.expiry) {
                localStorage.removeItem(key)
                return null
            }
            return item.value
        } catch (error) {
            localStorage.removeItem(key)
            return null
        }
    }

    useEffect(() => {
        const bannerHidden = getWithExpiry("hide_sell_a_gun_banner")

        if (bannerHidden) {
            setIsDismissed(true)
            return
        }

        const handleScroll = () => {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop

            if (scrollTop > 100) {
                if (!isDismissed) {
                    setIsVisible(true)
                }
            } else {
                setIsVisible(false)
            }
        }

        window.addEventListener("scroll", handleScroll)

        // Cleanup
        return () => window.removeEventListener("scroll", handleScroll)
    }, [isDismissed])

    const handleDismiss = () => {
        setIsDismissed(true)
        setIsVisible(false)

        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000
        setWithExpiry("hide_sell_a_gun_banner", true, thirtyDaysInMs)
    }

    return (
        <>
            {isVisible && (
                <div
                    className={`fixed w-full bg-[#151515] max-w-[1300px] h-[50px] bottom-0 left-1/2 transform -translate-x-1/2 bg-gradient-to-r text-white px-6 py-3 md:rounded-t-md flex items-center justify-center shadow-lg transition-all duration-300 ease-in-out z-50 ${
                        isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 -translate-y-2"
                    }`}
                >
                    <div
                        className="flex gap-2 text-[14px] md:text-[18px] flex-row consignment-btns"
                        style={{ fontFamily: "Poppins" }}
                    >
                        <span>Want cash fast?</span>
                        <span>
                            <Link
                                data-aos="fade-left"
                                href="/sell-my-gun"
                                className=""
                            >
                                <span className="font-semibold text-white ">
                                    Sell your gun!
                                </span>
                            </Link>
                        </span>
                    </div>

                    <button
                        onClick={handleDismiss}
                        className="absolute p-1 ml-4 transition-colors duration-200 rounded-full top-2 right-2 hover:bg-white/20"
                        aria-label="Dismiss banner"
                    >
                        <X size={16} />
                    </button>
                </div>
            )}
        </>
    )
}

export default SellAGunBanner
